<template>
    <el-popover placement="bottom">
        <div class="flex-box nopadding text-hd small only pd-left5 pd-right5 hand" slot="reference">
            <div class="flex-box-bd"></div>
            <Icon type="md-apps" />
            <Icon type="md-arrow-dropdown" class="mg-left3" />
            <div class="flex-box-bd"></div>
        </div>
        <div style="max-height:60vh;overflow-y: auto">
            <div v-for="(key,index) in Object.keys($parent.$parent.listHeader)" :key="key">
                <el-checkbox :value="shows[key]" @change="showsChange(key)" :disabled="index == 0">
                    {{$parent.$parent.listHeader[key]}}
                </el-checkbox>
            </div>
        </div>
        <div class="mg-top10 tright" v-if="save_flag">
            <el-button type="primary" size="small" @click="submit">确认</el-button>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: "myShowHeaderBtn",

        data: function(){
            return {
                fid: '',
                shows: {},
                save_flag: false
            }
        },
        mounted:function(){
            this.fid = this.$base.getRequest().fid;
            var old = this.$base.getCookie('TableHeader-' + this.fid);

            if(old){
                this.shows = old;
                Object.keys(this.shows).forEach(key =>{
                    this.$parent.$parent.listHeaderHide[key] = this.shows[key]?false:true;
                });
            }
            else{
                Object.keys(this.$parent.$parent.listHeader).forEach(key =>{
                    this.shows[key] = true;
                });
            }
            this.$forceUpdate();
        },
        methods:{
            showsChange(key){
                this.save_flag = true;
                this.shows[key] = this.shows[key]?false:true;
                this.$forceUpdate();
            },
            submit(){
                this.save_flag = false;
                this.$base.setCookie('TableHeader-' + this.fid, this.shows);

                Object.keys(this.shows).forEach(key =>{
                    this.$parent.$parent.listHeaderHide[key] = this.shows[key]?false:true;
                });
                this.$parent.$parent.$forceUpdate();
                this.$base.bodyClick();
			}
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myShowHeaderBtn.vue